export default __webpack_public_path__ + "img/236e5ac954961aadb013fc1d73bf07e1.svg";